import React, { useState } from "react";
import {
  IRecordResponse,
  IRecordRequest,
  IMaster,
  IService
} from "app/api/types";
import EditRecordForm from "app/components/EditRecordForm";

import "./styles.scss";

interface IProps {
  record: IRecordResponse;
  onSubmit: (data: IRecordRequest) => void;
  onDelete: (id: number) => void;
  masterList: IMaster[];
  serviceList: IService[];
}

const Record: React.FC<IProps> = props => {
  const [isCollapsed, setCollapse] = useState(true);
  const [isDeleting, setDelete] = useState(false);

  const triggerCollapse = () => {
    !props.record.is_added_by_admin && setCollapse(!isCollapsed);
  };

  const onDelete = () => {
    setDelete(true);
    props.onDelete(props.record.id);
  };

  const styles = {
    height: !isCollapsed ? "590px" : "60px",
    background: props.record.is_accepted ? "rgb(239, 255, 239)" : ""
  };

  return (
    <>
      <p className="time">
        {props.record.time_start} — {props.record.time_end}
      </p>
      <div
        className={`phrase-container ${isDeleting ? "deleting" : ""}`}
        style={styles}
      >
        <div className="phrase-wrapper">
          <div className="left-block" onClick={triggerCollapse}>
            <div className="phrase-text">{props.record.customer_name}</div>
            <div className="phrase-translation">
              {props.record.customer_phone}
            </div>
          </div>

          <div className="right-block">
            <p className="phrase-del" onClick={onDelete}>
              удалить
            </p>
          </div>
        </div>

        <EditRecordForm
          record={props.record}
          serviceList={props.serviceList}
          masterList={props.masterList}
          onSubmit={props.onSubmit}
          isActive={!isCollapsed}
        />
      </div>
    </>
  );
};

export default Record;
